import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SignIn, SignUp } from "@clerk/react";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import RequireAuth from "@/components/auth/RequireAuth";
import { MeProvider } from "@/context/MeContext";
import { Toaster } from "@/components/ui/sonner";
import SiteHeader from "@/components/layout/SiteHeader";
import SiteFooter from "@/components/layout/SiteFooter";
import Home from "@/pages/Home";
import Explore from "@/pages/Explore";
import GuideMe from "@/pages/GuideMe";
import Lander from "@/pages/Lander";
import ListingDetail from "@/pages/ListingDetail";
import Checkout from "@/pages/Checkout";
import Trips from "@/pages/Trips";
import GuestPortal from "@/pages/GuestPortal";
import PartnerHome from "@/pages/PartnerHome";
import PartnerListing from "@/pages/PartnerListing";
import Admin from "@/pages/Admin";

const AuthPage = ({ children }) => (
  <div className="flex min-h-[80vh] items-center justify-center px-4 py-16">{children}</div>
);

function App() {
  return (
    <BrowserRouter>
      <ClerkAuthProvider>
        <MeProvider>
          <div className="flex min-h-screen flex-col">
            <SiteHeader />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/explore" element={<Explore />} />
                <Route path="/guide-me" element={<GuideMe />} />
                <Route path="/escapes/:key" element={<Lander />} />
                <Route path="/l/:slug" element={<ListingDetail />} />
                <Route path="/checkout/:id" element={<RequireAuth><Checkout /></RequireAuth>} />
                <Route path="/trips" element={<RequireAuth><Trips /></RequireAuth>} />
                <Route path="/trips/:id" element={<RequireAuth><GuestPortal /></RequireAuth>} />
                <Route path="/partner" element={<RequireAuth><PartnerHome /></RequireAuth>} />
                <Route path="/partner/listings/:id" element={<RequireAuth roles={["partner", "admin"]}><PartnerListing /></RequireAuth>} />
                <Route path="/admin" element={<RequireAuth roles={["admin"]}><Admin /></RequireAuth>} />
                <Route path="/sign-in/*" element={<AuthPage><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp /></AuthPage>} />
                <Route path="/sign-up/*" element={<AuthPage><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" /></AuthPage>} />
              </Routes>
            </main>
            <SiteFooter />
          </div>
          <Toaster position="top-center" />
        </MeProvider>
      </ClerkAuthProvider>
    </BrowserRouter>
  );
}

export default App;
